"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var styles_1 = require("@material-ui/core/styles");
var kinsideTokens_1 = require("./kinsideTokens");
var baseTheme = styles_1.createTheme();
exports.theme = styles_1.createTheme({
    palette: {
        primary: {
            main: kinsideTokens_1.kinsideTokens["--viridian-50"],
            dark: kinsideTokens_1.kinsideTokens["--viridian-60"],
            contrastText: kinsideTokens_1.kinsideTokens["--gray-0"],
            light: kinsideTokens_1.kinsideTokens["--viridian-10"],
        },
        secondary: {
            main: kinsideTokens_1.kinsideTokens["--viridian-10"],
            dark: kinsideTokens_1.kinsideTokens["--viridian-80"],
            contrastText: kinsideTokens_1.kinsideTokens["--gray-0"],
            light: kinsideTokens_1.kinsideTokens["--viridian-5"],
        },
        error: {
            main: kinsideTokens_1.kinsideTokens["--coral-60"],
            dark: kinsideTokens_1.kinsideTokens["--coral-80"],
            contrastText: kinsideTokens_1.kinsideTokens["--coral-80"],
            light: kinsideTokens_1.kinsideTokens["--coral-10"],
        },
        warning: {
            main: kinsideTokens_1.kinsideTokens["--gold-10"],
            dark: kinsideTokens_1.kinsideTokens["--coral-80"],
            contrastText: kinsideTokens_1.kinsideTokens["--gold-80"],
            light: kinsideTokens_1.kinsideTokens["--gold-0"],
        },
        info: {
            main: kinsideTokens_1.kinsideTokens["--periwinkle-20"],
            dark: kinsideTokens_1.kinsideTokens["--periwinkle-80"],
            contrastText: kinsideTokens_1.kinsideTokens["--periwinkle-80"],
            light: kinsideTokens_1.kinsideTokens["--periwinkle-10"],
        },
        background: {
            default: "#fff",
        },
        text: {
            primary: kinsideTokens_1.kinsideTokens["--gray-80"],
        },
    },
    typography: {
        fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
        fontSize: 16,
        body1: {
            fontSize: 16,
            fontWeight: 300,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
            fontVariant: "lining-nums",
        },
        body2: {
            fontSize: 14,
            fontWeight: 500,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
            fontVariant: "lining-nums",
        },
        h1: {
            fontSize: 24,
            fontFamily: kinsideTokens_1.kinsideTokens["--serif"],
            fontWeight: 700,
            color: kinsideTokens_1.kinsideTokens["--viridian-60"],
        },
        h2: {
            fontSize: 18,
            fontFamily: kinsideTokens_1.kinsideTokens["--serif"],
            fontWeight: 700,
            color: kinsideTokens_1.kinsideTokens["--viridian-60"],
        },
        h3: {
            fontSize: 14,
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 700,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
        },
        h4: {
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 700,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
        },
        h5: {
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 700,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
        },
        h6: {
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 700,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
        },
        subtitle1: {
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 300,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
        },
        subtitle2: {
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 300,
            color: kinsideTokens_1.kinsideTokens["--gray-80"],
        },
        button: {
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 300,
        },
        caption: {
            fontStyle: "italic",
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 300,
        },
        overline: {
            fontStyle: "italic",
            fontFamily: kinsideTokens_1.kinsideTokens["--sans-serif"],
            fontWeight: 300,
        },
    },
    overrides: {
        MuiRadio: {
            colorPrimary: {
                color: kinsideTokens_1.kinsideTokens["--gray-50"],
                '&$checked': {
                    color: kinsideTokens_1.kinsideTokens["--gray-80"],
                },
            },
            colorSecondary: {
                color: kinsideTokens_1.kinsideTokens["--gray-50"],
                '&$checked': {
                    color: kinsideTokens_1.kinsideTokens["--gray-80"],
                },
            },
        },
        MuiChip: {
            root: {
                color: kinsideTokens_1.kinsideTokens["--gray-80"],
                backgroundColor: kinsideTokens_1.kinsideTokens["--gray-5"],
                height: 28,
                borderRadius: 8,
                "&.chip-periwinkle-light": {
                    color: kinsideTokens_1.kinsideTokens["--periwinkle-80"],
                    backgroundColor: kinsideTokens_1.kinsideTokens["--periwinkle-0"],
                },
            },
        },
        MuiLink: {
            root: {
                cursor: "pointer",
                "&.link-periwinkle": {
                    color: kinsideTokens_1.kinsideTokens["--periwinkle-50"],
                },
            },
        },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: "#fff",
                color: "theme.palette.primary.main",
            },
        },
        MuiContainer: {
            root: {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        MuiCard: {
            root: {
                marginTop: 8,
                marginBottom: 8,
                borderRadius: 16,
                border: "1px solid " + kinsideTokens_1.kinsideTokens["--viridian-10"],
            },
        },
        MuiAccordion: {
            root: {
                border: "1px solid " + kinsideTokens_1.kinsideTokens["--viridian-10"],
                backgroundColor: "#fff",
                boxShadow: "none",
                position: "unset",
                "&$expanded": {
                    margin: "8px 0",
                    marginTop: "0px",
                },
            },
            rounded: {
                borderRadius: 16,
                "&:last-child": {
                    borderBottomLeftRadius: 16,
                    borderBottomRightRadius: 16,
                },
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: 30,
            },
        },
        MuiDivider: {
            root: {
                marginBottom: 16,
                height: 1,
                backgroundColor: kinsideTokens_1.kinsideTokens["--viridian-10"],
            },
        },
        MuiPaper: {
            rounded: {
                borderRadius: "16px",
            },
        },
        MuiDialog: {
            root: {
                backdropFilter: "blur(8px)",
            },
            paper: (_a = {
                    padding: "16px 24px 24px 24px",
                    borderRadius: 24
                },
                _a[baseTheme.breakpoints.down("xs")] = {
                    padding: 8,
                    margin: "10px",
                },
                _a),
            paperScrollPaper: (_b = {},
                _b[baseTheme.breakpoints.down("xs")] = {
                    maxHeight: "calc( 100% - 16px)",
                },
                _b),
            paperFullWidth: (_c = {},
                _c[baseTheme.breakpoints.down("xs")] = {
                    width: "calc(100% - 16px)",
                },
                _c),
        },
        MuiDialogTitle: {
            root: {
                padding: 0,
                flex: 1,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
            },
        },
        MuiDialogContent: {
            dividers: {
                padding: "24px 0px 0px 0px",
                borderTop: "1px solid " + kinsideTokens_1.kinsideTokens["--viridian-10"],
                borderBottom: "1px solid " + kinsideTokens_1.kinsideTokens["--viridian-10"],
            },
        },
        MuiSnackbarContent: {
            root: {
                borderRadius: 16,
            },
        },
        MuiButton: {
            root: {
                fontWeight: 300,
                fontSize: "16px",
                borderRadius: "32px",
                padding: "8px 16px",
                alignSelf: "center",
                boxShadow: "none",
                textTransform: "unset",
            },
            containedSizeSmall: {
                padding: "8px 16px",
            },
            containedPrimary: {
                boxShadow: "none",
                "&:hover": {
                    boxShadow: "none",
                },
                "&.button-periwinkle-light": {
                    backgroundColor: kinsideTokens_1.kinsideTokens["--periwinkle-5"],
                    color: kinsideTokens_1.kinsideTokens["--periwinkle-80"],
                    "&:hover": {
                        backgroundColor: kinsideTokens_1.kinsideTokens["--periwinkle-20"],
                    },
                },
                "&.button-coral": {
                    backgroundColor: kinsideTokens_1.kinsideTokens["--coral-20"],
                    color: kinsideTokens_1.kinsideTokens["--coral-80"],
                    "&:hover": {
                        backgroundColor: kinsideTokens_1.kinsideTokens["--coral-30"],
                    },
                },
                "&.button-periwinkle-dark": {
                    backgroundColor: kinsideTokens_1.kinsideTokens["--periwinkle-20"],
                    color: kinsideTokens_1.kinsideTokens["--periwinkle-80"],
                    "&:hover": {
                        backgroundColor: kinsideTokens_1.kinsideTokens["--periwinkle-40"],
                    },
                },
            },
            containedSecondary: {
                color: kinsideTokens_1.kinsideTokens["--viridian-80"],
                boxShadow: "none",
                "&:hover": {
                    backgroundColor: kinsideTokens_1.kinsideTokens["--viridian-80"],
                    color: kinsideTokens_1.kinsideTokens["--gray-0"],
                    boxShadow: "none",
                },
            },
            outlinedSizeSmall: {
                padding: "8px 16px",
            },
            outlinedPrimary: {
                boxShadow: "none",
                backgroundColor: "#fff",
                "&:hover": {
                    backgroundColor: "#fff",
                    color: kinsideTokens_1.kinsideTokens["--viridian-80"],
                },
            },
            outlinedSecondary: {
                "&:hover": {
                    backgroundColor: kinsideTokens_1.kinsideTokens["--viridian-10"],
                    color: kinsideTokens_1.kinsideTokens["--viridian-80"],
                },
                boxShadow: "none",
            },
        },
        MuiIconButton: {
            root: {
                fontWeight: 500,
                "&:hover": {
                    backgroundColor: "white",
                    "& path": {
                        fill: "black",
                    },
                },
            },
        },
        MuiInputLabel: {
            root: {
                fontWeight: 500,
                marginBottom: 8,
            },
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 8,
            },
            notchedOutline: {
                borderColor: kinsideTokens_1.kinsideTokens["--gray-50"],
            },
        },
        MuiInputBase: {
            root: {
                backgroundColor: kinsideTokens_1.kinsideTokens["--gray-0"],
            },
        },
        MuiTab: {
            root: {
                textTransform: "unset",
            },
            textColorPrimary: {
                color: kinsideTokens_1.kinsideTokens["--viridian-60"],
                "&.Mui-selected": {
                    color: kinsideTokens_1.kinsideTokens["--viridian-80"],
                },
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: "1px solid " + kinsideTokens_1.kinsideTokens["--viridian-10"],
                cursor: "pointer",
            },
        },
        MuiTableRow: {
            root: {
                "&:last-child td": {
                    borderBottom: 0,
                },
            },
        },
        MuiListItem: {
            button: {
                "&:hover": {
                    marginLeft: "2px",
                    backgroundColor: "white",
                    "& span": {
                        fontWeight: "500",
                    },
                },
                "&$selected": {
                    backgroundColor: "white",
                    "& span": {
                        fontWeight: "700",
                    },
                    "&:hover": {
                        backgroundColor: "white",
                    },
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1136,
            xl: 1536,
        },
    },
});
